"use client";

import SegmentError from "@/components/routes/segment-error";

export default function AuthError(props: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<SegmentError
			{...props}
			segment="auth"
			title="Sign-in unavailable"
			description="We couldn't complete the sign-in flow. Try again, or return home and sign in from there."
			escapeHref="/"
			escapeLabel="Back to home"
		/>
	);
}
